import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Spinner, Tab, Tabs } from "react-bootstrap";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";
import AttachbyuserComplianceuser from '../../Components/Attachbyuserfiltercomplianceuser/Attachbyuserfiltercomplianceuser'

const AddCampaignUsers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams(); // ✅ get campaign ID from URL

  const [isLoading, setIsLoading] = useState(false);
  const [data, setUsers] = useState([]); // ✅ safe initial value
  const [links, setLinks] = useState([]);
  const [formData, setFormData] = useState({ user_ids: [] });
// Row checkbox toggle
const handleCheckboxChange = (id) => {
  const alreadySelected = formData.user_ids.includes(id.toString());
  
  const updated = alreadySelected
    ? formData.user_ids.filter(uid => uid !== id.toString())
    : [...formData.user_ids, id.toString()];

  setFormData({ ...formData, user_ids: updated });
};

// Page level Select All
const handleSelectAll = (e) => {
  const { checked } = e.target;
  const currentPageIds = data.map(u => u.id.toString());

  if (checked) {
    const merged = [...new Set([...(formData.user_ids || []), ...currentPageIds])];
    setFormData({ ...formData, user_ids: merged });
  } else {
    const filtered = formData.user_ids.filter(id => !currentPageIds.includes(id));
    setFormData({ ...formData, user_ids: filtered });
  }
};

const fetchLcUserModal = async (url = '') => {
  let finalUrl = url ? url : `${api_url}/compliance-campaigns/${id}/get-users`;

  try {
    const token = localStorage.getItem("userToken");
    const response = await fetch(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    setUsers(result?.data.data || []);
    setLinks(result?.data.links || []);
  } catch (error) {
    console.error(error);
    showToast(t("errorFetchingData"), "error");
  }
};


  useEffect(() => {
    if (id) {
      fetchLcUserModal();
    }
  }, [id]);

  const handleChange = (event) => {
    const { options } = event.target;
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => option.value);

    setFormData({
      ...formData,
      user_ids: selectedValues,
    });
  };

  const handleAddLcUserModal = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/compliance-campaigns/assign-users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...formData,
          campaign_id: id, // Ensure campaign ID is included
        }),
      });

      if (response.ok) {
        showToast(t("selectedCampaignUsersAddedSuccessfully"), "success");
        setFormData({ user_ids: [] });
        navigate(-1); // Go back
      } else {
        const result = await response.json();
        showToast(t(result.message) || result.message, "error");
      }
    } catch (error) {
      showToast(t("somethingWentWrong"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ border: "1px solid #EAEAEA", borderRadius: "10px", padding: "26px", margin: "20px" }}>
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => navigate(-1)}>{t('Back')}</Button>
      </div>

      <Tabs defaultActiveKey="AddVideo" className="mb-3">
        <Tab eventKey="AddVideo" title={t("AddCampaignUsers")}>
          <form onSubmit={handleAddLcUserModal}>
          <div className="mb-2">
  <input 
    type="checkbox"
    onChange={handleSelectAll}
    checked={
      data.length > 0 &&
      data.every(u => formData.user_ids.includes(u.id.toString()))
    }
  />
  <span style={{ marginLeft: "6px" }}>{t("SelectAllUsers")}</span>
</div>

<table className="table table-bordered">
  <thead>
    <tr>
      <th>{t("Select")}</th>
      <th>{t("Username")}</th>
      <th>{t("Email")}</th>
    </tr>
  </thead>

  <tbody>
    {data.length === 0 ? (
      <tr>
        <td colSpan="3">{t("Nousersavailable")}</td>
      </tr>
    ) : (
      data.map((user) => (
        <tr key={user.id}>
          <td>
            <input
              type="checkbox"
              checked={formData.user_ids.includes(user.id.toString())}
              onChange={() => handleCheckboxChange(user.id)}
            />
          </td>
          <td>{user.username}</td>
          <td>{user.email}</td>
        </tr>
      ))
    )}
  </tbody>
</table>


            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                  {t('Adding...')}
                </>
              ) : (
                t('AddUser')
              )}
            </button>
          </form>

          <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null
                  ? () => fetchLcUserModal(link.url)
                  : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
        </Tab>
        <Tab eventKey="AttachbyuserfilterPhishingcampaign" title={t("AddComplianceUsersUsingQuery")}>
            <AttachbyuserComplianceuser />
          </Tab>
      </Tabs>
    </div>
  );
};

export default AddCampaignUsers;
